<app-loadable-content [loadingController]="businessLoadingController" (onRetry)="loadBusiness()">
    <table width="100%">
        <tr>
            <td align="center">
                <app-business-header [business]="business"></app-business-header>
            </td>
        </tr>
        <tr>
            <td align="center">
                <app-toolbar [subject]="business" [actions]="businessToolbarModel.actions" [compactActions]="businessToolbarModel.compactActions"></app-toolbar>
            </td>
        </tr>
        <tr>
            <td  align="center">
                <h3> {{ 'logo' | translate}} </h3>
                <table>
                    <tr>
                        <td>
                            <app-file-selector icon="edit" [tooltip]="'edit' | translate" fileChooserAcceptFilter="image/*" (onFileSelected)="updateBusinessLogo($event)"></app-file-selector>
                        </td>
                        <td>
                            <app-action icon="delete" [tooltip]="'delete' | translate" (click)="deleteBusinessLogo()"></app-action>
                        </td>
                    </tr>
                </table>
                <div class="container-with-overlay">
                    <img [src]="logoUrl" *ngIf="business.logo"
                        [ngClass]="deviceService.ifMobile('logo-mobile').orElse('logo')">
                    <app-no-image-placeholder matTooltip="Logo" *ngIf="!business.logo"></app-no-image-placeholder>
                    <!--
                    <div class="container-overlay-top-right-12px-outside">
                        <table>
                            <tr>
                                <td>
                                    <app-file-selector [isMiniFab]="true" icon="edit" [tooltip]="'edit' | translate" fileChooserAcceptFilter="image/*" (onFileSelected)="updateBusinessLogo($event)"></app-file-selector>
                                </td>
                                <td>
                                    <app-action icon="delete" [tooltip]="'delete' | translate" (click)="deleteBusinessLogo()"></app-action>
                                </td>
                            </tr>
                        </table>
                    </div>
                    -->
                </div>
            </td>
        </tr>
        <tr><td>&nbsp;</td></tr>
        <tr>
            <td  align="center">
                <h3> {{ 'home_header_landscape' | translate}} </h3>
                <table>
                    <tr>
                        <td>
                            <app-file-selector icon="edit" [tooltip]="'edit' | translate" fileChooserAcceptFilter="image/*" (onFileSelected)="updateBusinessHomeHeaderForLandscapeScreen($event)"></app-file-selector>
                        </td>
                        <td>
                            <app-action icon="delete" [tooltip]="'delete' | translate" (click)="deleteBusinessHomeHeaderForLandscapeScreen()"></app-action>
                        </td>
                    </tr>
                </table>
                <div class="container-with-overlay">
                    <img [src]="homeHeaderForLandscapeScreenUrl" *ngIf="homeHeaderForLandscapeScreenUrl"
                        [ngClass]="deviceService.ifMobile('header-for-landscape-screen-mobile').orElse('header-for-landscape-screen')">
                    <app-no-image-placeholder matTooltip="Header" *ngIf="!homeHeaderForLandscapeScreenUrl"></app-no-image-placeholder>
                </div>
            </td>
        </tr>
        <tr>
            <td  align="center">
                <h3> {{ 'home_header_portrait' | translate}} </h3>
                <table>
                    <tr>
                        <td>
                            <app-file-selector icon="edit" [tooltip]="'edit' | translate" fileChooserAcceptFilter="image/*" (onFileSelected)="updateBusinessHomeHeaderForPortraitScreen($event)"></app-file-selector>
                        </td>
                        <td>
                            <app-action icon="delete" [tooltip]="'delete' | translate" (click)="deleteBusinessHomeHeaderForPortraitScreen()"></app-action>
                        </td>
                    </tr>
                </table>
                <div class="container-with-overlay">
                    <img [src]="homeHeaderForPortraitScreenUrl" *ngIf="homeHeaderForPortraitScreenUrl"
                    [ngClass]="deviceService.ifMobile('header-for-portrait-screen-mobile').orElse('header-for-portrait-screen')">
                    <app-no-image-placeholder matTooltip="Header" *ngIf="!homeHeaderForPortraitScreenUrl"></app-no-image-placeholder>
                </div>
            </td>
        </tr>
        <tr><td>&nbsp;</td></tr>
        <tr>
            <td  align="center">
                <h3> {{ 'menu_header_landscape' | translate}} </h3>
                <table>
                    <tr>
                        <td>
                            <app-file-selector icon="edit" [tooltip]="'edit' | translate" fileChooserAcceptFilter="image/*" (onFileSelected)="updateBusinessMenuHeaderForLandscapeScreen($event)"></app-file-selector>
                        </td>
                        <td>
                            <app-action icon="delete" [tooltip]="'delete' | translate" (click)="deleteBusinessMenuHeaderForLandscapeScreen()"></app-action>
                        </td>
                    </tr>
                </table>
                <div class="container-with-overlay">
                    <img [src]="menuHeaderForLandscapeScreenUrl" *ngIf="menuHeaderForLandscapeScreenUrl"
                        [ngClass]="deviceService.ifMobile('header-for-landscape-screen-mobile').orElse('header-for-landscape-screen')">
                    <app-no-image-placeholder matTooltip="Header" *ngIf="!menuHeaderForLandscapeScreenUrl"></app-no-image-placeholder>
                    <!--
                    <div class="container-overlay-top-right-12px-outside">
                        <table>
                            <tr>
                                <td>
                                    <app-file-selector [isMiniFab]="true" icon="edit" [tooltip]="'edit' | translate" fileChooserAcceptFilter="image/*" (onFileSelected)="updateBusinessMenuHeaderForLandscapeScreen($event)"></app-file-selector>
                                </td>
                                <td>
                                    <app-action icon="delete" [tooltip]="'delete' | translate" (click)="deleteBusinessMenuHeaderForLandscapeScreen()"></app-action>
                                </td>
                            </tr>
                        </table>
                    </div>
                    -->
                </div>
            </td>
        </tr>
        <tr>
            <td  align="center">
                <h3> {{ 'menu_header_portrait' | translate}} </h3>
                <table>
                    <tr>
                        <td>
                            <app-file-selector icon="edit" [tooltip]="'edit' | translate" fileChooserAcceptFilter="image/*" (onFileSelected)="updateBusinessMenuHeaderForPortraitScreen($event)"></app-file-selector>
                        </td>
                        <td>
                            <app-action icon="delete" [tooltip]="'delete' | translate" (click)="deleteBusinessMenuHeaderForPortraitScreen()"></app-action>
                        </td>
                    </tr>
                </table>
                <div class="container-with-overlay">
                    <img [src]="menuHeaderForPortraitScreenUrl" *ngIf="menuHeaderForPortraitScreenUrl"
                    [ngClass]="deviceService.ifMobile('header-for-portrait-screen-mobile').orElse('header-for-portrait-screen')">
                    <app-no-image-placeholder matTooltip="Header" *ngIf="!menuHeaderForPortraitScreenUrl"></app-no-image-placeholder>
                    <!--
                    <div class="container-overlay-top-right-12px-outside">
                        <table>
                            <tr>
                                <td>
                                    <app-file-selector [isMiniFab]="true" icon="edit" [tooltip]="'edit' | translate" fileChooserAcceptFilter="image/*" (onFileSelected)="updateBusinessMenuHeaderForPortraitScreen($event)"></app-file-selector>
                                </td>
                                <td>
                                    <app-action icon="delete" [tooltip]="'delete' | translate" (click)="deleteBusinessMenuHeaderForPortraitScreen()"></app-action>
                                </td>
                            </tr>
                        </table>
                    </div>
                    -->
                </div>
            </td>
        </tr>
    </table>
</app-loadable-content>
